<script>
    import { X } from "lucide-svelte";
    import { helpOpen, closeHelp } from "/stores/help.js";

    const helpSections = [
        {
            title: "대시보드",
            items: [
                {
                    menu: "대시보드",
                    description:
                        "현재 워크스페이스의 주요 현황을 요약해 확인하는 첫 화면입니다.",
                },
            ],
        },
        {
            title: "기초 정보",
            items: [
                {
                    menu: "관리 사업자",
                    description:
                        "사업자가 여러 개인 경우 등록하여 사용합니다. (옵션)",
                    details: [
                        {
                            term: "기본정보-명세서메모",
                            text: "거래명세서 메모란에 자동 적용되는 항목으로, 입금계좌 정보 등을 사전에 입력합니다.",
                        },
                        {
                            term: "계좌 및 세금계산서",
                            text: "하이웍스 가입 후 발급되는 토큰 정보와 계좌 정보를 등록하여 세금계산서 발행 및 계좌 조회를 실시합니다.",
                        },
                        {
                            term: "CMS 설정",
                            text: "자동이체 및 현금영수증 발행을 위한 설정 메뉴이며, 현재는 효성CMS만 지원합니다.",
                        },
                        {
                            term: "명세서 발송 설정",
                            text: "거래명세서를 메일로 발송할 경우 사전에 메일 내용을 설정합니다.",
                        },
                    ],
                },
                {
                    menu: "구성원",
                    description:
                        "사원을 등록하는 메뉴이며, 부여하는 권한에 따라 이용 가능한 메뉴가 달라집니다.",
                    details: [
                        {
                            term: "사원",
                            text: "A/S를 위한 메뉴 중심으로 이용하며, 보통 엔지니어에게 할당하는 권한입니다.",
                        },
                        {
                            term: "매니저",
                            text: "모든 메뉴를 이용할 수 있으며, 대표 또는 관리부 직원이 이용합니다.",
                        },
                        {
                            term: "원격지원",
                            text: "유지보수가 필요할 때 생성하여 제공하는 권한으로, 고객명은 보이지 않습니다.",
                        },
                    ],
                },
                {
                    menu: "창고",
                    description: "창고를 관리하기 위한 메뉴입니다.",
                    details: [
                        {
                            term: "창고명",
                            text: "사무실은 선반을 구분해 등록하면 편리하며(예: 선반A 1단, 2단), 엔지니어가 차량을 보유한 경우 엔지니어 이름으로 등록합니다.",
                        },
                        {
                            term: "창고 상세",
                            text: "창고를 구분하기 위한 메모로, 차량번호도 등록합니다.",
                        },
                        {
                            term: "관리자",
                            text: "엔지니어 창고는 담당 엔지니어를, 사무실 창고는 내부 인원을 선택합니다.",
                        },
                        {
                            term: "창고 공유",
                            text: "엔지니어는 자기 차량 창고만 보이지만, 차량을 공유하는 업체에서는 창고를 '공유'로 선택하면 모두 볼 수 있습니다.",
                        },
                    ],
                },
                {
                    menu: "사용자 정의 모델",
                    description:
                        "복합기·프린터 등은 이미 등록된 리스트에서 선택하지만, 리스트에 없는 독자적인 물품(가구, 비품 종류 등)을 렌탈·판매할 경우 임의로 등록해 사용하기 위한 항목입니다.",
                },
                {
                    menu: "부소모품 코드",
                    description:
                        "부소모품을 등록하여 사용합니다. 제조사 코드로 등록해도 되고, 업체 고유 코드로 등록해 사용해도 무방합니다.",
                },
                {
                    menu: "고객",
                    description:
                        "관리하는 고객을 등록합니다. 매출이 발생하는 고객, 매입처, 관리사업자에 등록한 사업자를 모두 등록합니다.",
                    details: [
                        {
                            text: "고객 등록 시 빈 항목 없이 모두 입력해야 합니다.",
                        },
                        {
                            text: "파일로 등록하는 경우 거점이 1개인 고객은 반드시 거점명을 '본사'로 등록해야 합니다.",
                        },
                        {
                            text: "거점이 여러 개인 고객도 본사는 '본사'로 등록해야 합니다.",
                        },
                        {
                            term: "에이전트 코드",
                            text: "복합기·프린터를 모니터링하기 위한 프로그램을 고객 PC에 설치할 때 입력하는 OTP 코드입니다.",
                        },
                    ],
                },
            ],
        },
        {
            title: "자산",
            items: [
                {
                    menu: "복합기·프린터 현황",
                    description:
                        "외부에서 구매한 장비를 등록하기 위한 메뉴입니다.",
                    details: [
                        {
                            text: "입고 등록 시 매입가를 입력하고 매입사업자를 선택한 뒤 '원장반영' 버튼에서 반영을 선택하면 거래원장에 자동 적용됩니다.",
                        },
                        {
                            text: "고객사에 장비를 설치하면 자동으로 '사용고객' 열에 고객명이 반영됩니다.",
                        },
                    ],
                },
                {
                    menu: "부소모품 입출고",
                    description:
                        "부소모품의 입고, 환입, 재고조정을 하는 메뉴입니다.",
                    details: [
                        {
                            term: "입고",
                            text: "외부에서 구매 시 원장 반영 여부를 선택합니다.",
                        },
                        {
                            term: "환입",
                            text: "고객사 철수 시 잔여 소모품을 가져오는 경우 사용합니다.",
                        },
                        {
                            term: "재고조정",
                            text: "실재고가 맞지 않을 경우 사용합니다.",
                        },
                        {
                            text: "A/S 시 사용한 부소모품은 자동으로 '사용고객' 열에 고객명이 반영됩니다.",
                        },
                    ],
                },
                {
                    menu: "부소모품 재고",
                    description: "현재 부소모품 재고를 실시간으로 확인합니다.",
                    details: [
                        {
                            term: "이동",
                            text: "창고에 있는 부소모품을 엔지니어에게 지급하거나 창고 위치를 변경할 경우 선택해 사용합니다.",
                        },
                    ],
                },
            ],
        },
        {
            title: "장비 관리",
            items: [
                {
                    menu: "복합기·프린터 관리",
                    description:
                        "에이전트 설치 시 등록되는 장비 리스트입니다. 상태를 '관리'로 선택하면 카운트·소모품 수집 대상이 되며 과금 대수로 산정됩니다.",
                    details: [
                        {
                            term: "SL",
                            text: "서비스 레벨로, 관리가 중요한 장비 순으로 1, 2, 3, N 중에서 선택하며 미지정도 가능합니다.",
                        },
                        {
                            term: "검지모델",
                            text: "에이전트에서 자동으로 인식한 모델명입니다.",
                        },
                        {
                            term: "관리모델",
                            text: "설치한 모델 번호를 일부 입력해 선택 등록합니다.",
                        },
                        {
                            term: "관리번호",
                            text: "자동 생성되는 번호로 고객 관리 시 사용합니다. (예: 복합기에 관리번호를 부착해 고객이 A/S 접수 시 관리번호 4자리를 확인 요청하여 접수)",
                        },
                        {
                            term: "추가",
                            text: "보안 이슈로 에이전트나 메일통지가 불가능한 환경은 수동으로 등록합니다. (A/S와 원장 관리를 위해 필수 등록)",
                        },
                    ],
                },
                {
                    menu: "메일수집장비 등록",
                    description:
                        "복합기의 메일통지를 활용해 카운트·소모품 상태를 파악합니다.",
                    details: [
                        {
                            text: "복합기 내 메타 수집용 이메일은 '내 정보-메타수집 이메일'에 설정된 이메일을 사용합니다.",
                        },
                        {
                            text: "에이전트 등록 후 메일통지를 설정하면 장비관리 메뉴에서 장비 상태를 다시 한번 '관리'로 선택해야 합니다.",
                        },
                    ],
                },
            ],
        },
        {
            title: "모니터링",
            items: [
                {
                    menu: "사용량",
                    description:
                        "카운트 모니터링 화면입니다. 3일간 수집을 하지 못한 경우 비활성 상태가 되어 아이콘이 흐리게 표시됩니다.",
                },
                {
                    menu: "소모품",
                    description:
                        "소모품 모니터링 화면입니다. 소모품 교체 또는 10% 이하 항목을 클릭하여 A/S를 즉시 접수할 수 있습니다.",
                },
                {
                    menu: "고객현황",
                    description:
                        "추가 영업을 위해 고객사 정보를 업데이트하는 메뉴입니다. PC 대수, 종업원 수, 복합기 대수, 프린터 대수 및 기타 정보를 입력·관리할 수 있습니다.",
                },
            ],
        },
        {
            title: "A/S",
            items: [
                {
                    menu: "접수",
                    description:
                        "A/S 접수 메뉴입니다. 수집장비-장비관리 메뉴에서 상태를 '관리'로 설정한 장비가 보입니다. 접수 시 요청자명·방문주소·연락처는 기초정보-고객 메뉴에 등록한 정보가 기본값으로 표시되며 수정할 수 있습니다.",
                },
                {
                    menu: "진행",
                    description: "A/S 미완료 리스트입니다.",
                    details: [
                        {
                            term: "빨강색",
                            text: "어제까지 미완료 상태인 A/S 접수 건입니다.",
                        },
                        {
                            term: "주황색",
                            text: "금일까지 방문 완료가 필요한 A/S 접수 건입니다.",
                        },
                        {
                            term: "검정색",
                            text: "명일 이후 방문이 필요한 A/S 접수 건입니다.",
                        },
                        {
                            term: "이력보기",
                            text: "해당 시리얼의 A/S 이력을 확인합니다.",
                        },
                        {
                            term: "전화하기",
                            text: "모바일에서 직접 전화를 연결합니다.",
                        },
                        {
                            term: "네비게이션",
                            text: "모바일에서 직접 내비로 연결합니다.",
                        },
                        {
                            term: "A/S 메타",
                            text: "메타가 자동 표시되며, 최근 수집일을 확인해 수기 입력·수정할 수 있습니다.",
                        },
                        {
                            term: "부소모품 출고",
                            text: "A/S 시 사용한 부소모품을 창고를 선택해 출고합니다. (엔지니어는 본인 차량 재고만 선택 가능)",
                        },
                    ],
                },
                {
                    menu: "완료",
                    description: "A/S 완료된 사항을 조회합니다.",
                },
                {
                    menu: "부소모품 사용 현황",
                    description:
                        "A/S 시 사용한 부소모품 사용 내역을 조회합니다. 담당 엔지니어/방문 엔지니어 별로 확인할 수 있으며 수량·금액 사용 현황을 조회합니다.",
                },
            ],
        },
        {
            title: "계약",
            items: [
                {
                    menu: "미계약 장비",
                    description:
                        "수집장비-장비관리 메뉴에서 상태가 '관리'로 설정된 장비 중 계약등록을 하지 않은 장비 리스트를 조회합니다. 고객을 클릭하여 신규 계약을 등록할 수 있습니다.",
                    details: [
                        {
                            term: "세금계산서 품목명",
                            text: "세금계산서 품목란에 표시하는 내용을 등록합니다. (복사료, 렌탈료 등)",
                        },
                        {
                            term: "업무담당자/계산서 담당자",
                            text: "기초정보-고객에 등록한 정보가 기본값으로 표시되며 수정할 수 있습니다.",
                        },
                    ],
                },
                {
                    menu: "계약 목록",
                    description:
                        "계약이 등록된 고객사 리스트입니다. 클릭하여 수정할 수 있습니다.",
                },
                {
                    menu: "계약 명세서 발행",
                    description:
                        "계약 등록 시 설정한 청구일에 거래명세서가 자동으로 발행됩니다. 발행된 명세서를 클릭 > 검토 > 확정 시 명세서 완료 메뉴에 저장됩니다.",
                    details: [
                        {
                            term: "계약번호",
                            text: "최근 1년간 발행된 명세서 리스트를 확인할 수 있습니다. (명세서 금액이 이상할 경우 이전 명세서 참조)",
                        },
                        {
                            term: "현재 카운트",
                            text: "수집이 안 되는 장비의 카운트를 입력할 수 있습니다. (수정 가능 항목)",
                        },
                        {
                            term: "최종공급가액",
                            text: "고객사와 개별 약정한 특약으로 금액 조정이 필요할 때 사용합니다. (수정 가능 항목)",
                        },
                        {
                            term: "메모",
                            text: "내용을 수정할 수 있습니다.",
                        },
                    ],
                },
                {
                    menu: "계약 명세서 완료",
                    description: "검토가 완료된 명세서가 저장되는 메뉴입니다.",
                    details: [
                        {
                            term: "개별발송",
                            text: "명세서를 클릭하고 하단의 [메일로 보내기] 버튼을 클릭해 발송합니다.",
                        },
                        {
                            term: "일괄발송",
                            text: "화면 왼쪽 체크박스를 선택하고 오른쪽 상단 [메일발송] 버튼을 클릭해 발송합니다.",
                        },
                    ],
                },
                {
                    menu: "판매/용역서비스 등록",
                    description:
                        "판매하는 품목을 선택하여 판매 등록합니다.",
                    details: [
                        {
                            term: "장비 선택",
                            text: "자산 > 장비현황 메뉴에 등록된 장비 리스트 중에서 선택하고 판매금액을 입력합니다.",
                        },
                        {
                            term: "부소모품 선택",
                            text: "자산 > 부소모품재고 메뉴에 등록된 리스트 중에서 선택하고 판매금액을 입력합니다.",
                        },
                        {
                            term: "부가항목 선택",
                            text: "배송료, 설치/철수비, A/S 출장료 등을 선택하고 금액을 입력합니다.",
                        },
                        {
                            text: "저장 후 화면 오른쪽 [명세서 보기]를 클릭해 명세서를 확인한 뒤 [확정]을 클릭하면 계약 > 판매완료 메뉴에 저장됩니다.",
                        },
                    ],
                },
                {
                    menu: "판매/용역서비스 완료",
                    description:
                        "발행 완료된 판매와 용역 서비스 내역을 조회합니다.",
                },
            ],
        },
        {
            title: "매출증빙",
            items: [
                {
                    menu: "세금계산서",
                    description:
                        "확정된 명세서·판매계약의 세금계산서를 건별로 발행·수정발행·취소하고 발행 상태를 확인합니다.",
                },
                {
                    menu: "현금영수증",
                    description:
                        "현금영수증 발행 대상을 건별로 발행·수정발행·취소합니다. 발급 업체(효성·NICEPAY)는 계약의 CMS 회원 또는 계약에서 고른 발급 업체로 정해집니다.",
                },
                {
                    menu: "증빙 완료",
                    description:
                        "매출증빙 발행이 완료된 항목과 처리 결과를 조회합니다.",
                },
            ],
        },
        {
            title: "계좌/CMS",
            items: [
                {
                    menu: "계좌 입출금",
                    description:
                        "기초정보-관리사업자의 '계좌 및 세금계산서' 탭에 등록한 계좌의 입출금 내역을 조회하고 거래원장에 반영합니다.",
                    details: [
                        {
                            term: "계좌 동기화",
                            text: "클릭하여 입출금 내역을 업데이트합니다.",
                        },
                        {
                            term: "수기 등록",
                            text: "계좌 조회를 API로 자동 조회하지 않고 개별로 수기 관리할 경우 입력하여 거래원장에 반영합니다.",
                        },
                    ],
                },
                {
                    menu: "CMS 회원 관리",
                    description:
                        "자동이체 대상 고객의 CMS 회원 정보를 등록하고 상태를 관리합니다.",
                },
            ],
        },
        {
            title: "원장",
            items: [
                {
                    menu: "거래 원장",
                    description:
                        "청구, 수납, 매출증빙 등 거래 흐름을 고객 기준으로 조회합니다.",
                },
                {
                    menu: "선수금 원장",
                    description:
                        "선수금 발생, 사용, 잔액 변동을 고객별로 확인합니다.",
                },
            ],
        },
        {
            title: "업무관리",
            items: [
                {
                    menu: "위약금 청구",
                    description:
                        "계약 해지나 약정 조건에 따라 발생하는 위약금 청구 대상을 검토하고 발행합니다.",
                },
            ],
        },
    ];

    // 창 위치 (드래그 이동). 최초 1회만 우측 상단 근처로 배치(posX===null = 미배치).
    let posX = null;
    let posY = null;

    const MIN_WIDTH = 360; // 최소 너비(px)
    const DEFAULT_WIDTH = 560; // 기본 너비(px, ≈35rem)
    const MIN_HEIGHT = 240; // 최소 높이(px)
    const DEFAULT_HEIGHT = 640; // 기본 높이(px)
    let winWidth = DEFAULT_WIDTH; // 창 너비 (드래그 리사이즈)
    let winHeight = DEFAULT_HEIGHT; // 창 높이 (드래그 리사이즈)

    let dragging = false;
    let dragOffsetX = 0;
    let dragOffsetY = 0;

    // 리사이즈 방향(x=너비, y=높이, both=우하단 모서리)
    let resizing = false;
    let resizeAxis = "";
    let resizeStartX = 0;
    let resizeStartY = 0;
    let resizeStartWidth = 0;
    let resizeStartHeight = 0;

    $: if ($helpOpen && posX === null) {
        posX = Math.max(16, window.innerWidth - winWidth - 32);
        posY = 88;
        // 기본 높이가 화면을 넘으면 뷰포트에 맞춰 축소
        winHeight = Math.min(DEFAULT_HEIGHT, window.innerHeight - posY - 16);
    }

    // 화면 밖으로 나가지 않는 최대 너비/높이
    $: maxWidth =
        typeof window !== "undefined" && posX !== null
            ? Math.max(MIN_WIDTH, window.innerWidth - posX - 16)
            : DEFAULT_WIDTH;
    $: maxHeight =
        typeof window !== "undefined" && posY !== null
            ? Math.max(MIN_HEIGHT, window.innerHeight - posY - 16)
            : DEFAULT_HEIGHT;

    function onHeaderPointerDown(e) {
        dragging = true;
        dragOffsetX = e.clientX - posX;
        dragOffsetY = e.clientY - posY;
        window.addEventListener("pointermove", onPointerMove);
        window.addEventListener("pointerup", onPointerUp);
    }

    function onPointerMove(e) {
        const maxX = window.innerWidth - 80;
        const maxY = window.innerHeight - 40;
        posX = Math.min(Math.max(-winWidth + 120, e.clientX - dragOffsetX), maxX);
        posY = Math.min(Math.max(0, e.clientY - dragOffsetY), maxY);
    }

    function onPointerUp() {
        dragging = false;
        window.removeEventListener("pointermove", onPointerMove);
        window.removeEventListener("pointerup", onPointerUp);
    }

    function onResizePointerDown(axis, e) {
        resizing = true;
        resizeAxis = axis;
        resizeStartX = e.clientX;
        resizeStartY = e.clientY;
        resizeStartWidth = winWidth;
        resizeStartHeight = winHeight;
        window.addEventListener("pointermove", onResizePointerMove);
        window.addEventListener("pointerup", onResizePointerUp);
    }

    function onResizePointerMove(e) {
        if (resizeAxis === "x" || resizeAxis === "both") {
            const nextW = resizeStartWidth + (e.clientX - resizeStartX);
            winWidth = Math.min(Math.max(MIN_WIDTH, nextW), maxWidth);
        }
        if (resizeAxis === "y" || resizeAxis === "both") {
            const nextH = resizeStartHeight + (e.clientY - resizeStartY);
            winHeight = Math.min(Math.max(MIN_HEIGHT, nextH), maxHeight);
        }
    }

    function onResizePointerUp() {
        resizing = false;
        resizeAxis = "";
        window.removeEventListener("pointermove", onResizePointerMove);
        window.removeEventListener("pointerup", onResizePointerUp);
    }

    // 열려 있을 때 Esc로 닫기
    function onKeydown(e) {
        if (e.key === "Escape") closeHelp();
    }
    $: if (typeof window !== "undefined") {
        if ($helpOpen) window.addEventListener("keydown", onKeydown);
        else window.removeEventListener("keydown", onKeydown);
    }
</script>

{#if $helpOpen}
    <div
        id="help-window"
        class="help-window"
        class:dragging
        class:resizing
        style="left: {posX}px; top: {posY}px; width: {winWidth}px; height: {winHeight}px;"
    >
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <header class="help-window-header" on:pointerdown={onHeaderPointerDown}>
            <h2>도움말</h2>
            <button
                type="button"
                class="help-window-close"
                aria-label="도움말 닫기"
                on:pointerdown|stopPropagation
                on:click={closeHelp}
            >
                <X size={18} />
            </button>
        </header>

        <div class="help-window-body">
            <table class="tableA help-table">
                <thead>
                    <tr>
                        <th class="menu-column">메뉴</th>
                        <th>기능 설명</th>
                    </tr>
                </thead>
                <tbody>
                    {#each helpSections as section}
                        <tr class="help-section-row">
                            <td colspan="2">{section.title}</td>
                        </tr>
                        {#each section.items as item}
                            <tr>
                                <td>{item.menu}</td>
                                <td>
                                    <p class="help-desc">{item.description}</p>
                                    {#if item.details}
                                        <ul class="help-details">
                                            {#each item.details as detail}
                                                <li>
                                                    {#if detail.term}<strong>{detail.term}</strong>: {/if}{detail.text}
                                                </li>
                                            {/each}
                                        </ul>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    {/each}
                </tbody>
            </table>
        </div>

        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <div
            class="help-window-resizer resizer-x"
            role="separator"
            aria-orientation="vertical"
            aria-label="도움말 너비 조정"
            title="드래그하여 너비 조정"
            on:pointerdown={(e) => onResizePointerDown("x", e)}
        ></div>
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <div
            class="help-window-resizer resizer-y"
            role="separator"
            aria-orientation="horizontal"
            aria-label="도움말 높이 조정"
            title="드래그하여 높이 조정"
            on:pointerdown={(e) => onResizePointerDown("y", e)}
        ></div>
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <div
            class="help-window-resizer resizer-corner"
            role="separator"
            aria-label="도움말 크기 조정"
            title="드래그하여 크기 조정"
            on:pointerdown={(e) => onResizePointerDown("both", e)}
        ></div>
    </div>
{/if}

<style>
    .help-window {
        position: fixed;
        z-index: 1100;
        /* 너비(width)·높이(height)는 컴포넌트에서 인라인으로 제어(드래그 리사이즈) */
        max-width: calc(100vw - 2rem);
        max-height: calc(100vh - 2rem);
        display: flex;
        flex-direction: column;
        background: var(--bg-default);
        border: 1px solid var(--table-border-color);
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        overflow: hidden;
    }

    .help-window.dragging,
    .help-window.resizing {
        user-select: none;
    }

    /* 리사이즈 핸들 공통 */
    .help-window-resizer {
        position: absolute;
        touch-action: none;
    }

    /* 우측 가장자리: 너비 조정 */
    .resizer-x {
        top: 0;
        right: 0;
        width: 8px;
        height: 100%;
        cursor: ew-resize;
    }

    /* 하단 가장자리: 높이 조정 */
    .resizer-y {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 8px;
        cursor: ns-resize;
    }

    /* 우하단 모서리: 너비·높이 동시 조정 */
    .resizer-corner {
        right: 0;
        bottom: 0;
        width: 14px;
        height: 14px;
        cursor: nwse-resize;
    }

    .help-window-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
        padding: 0.6rem 0.9rem;
        background: var(--primary-color);
        color: #fff;
        cursor: move;
    }

    .help-window-header h2 {
        margin: 0;
        font-size: 1rem;
        color: #fff;
    }

    .help-window-close {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.2rem;
        background: transparent;
        border: none;
        color: #fff;
        cursor: pointer;
    }

    .help-window-body {
        flex: 1;
        min-height: 0;
        padding: 1rem;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 1.25rem;
    }

    /* 도움말 표는 헤더를 상단에 고정하지 않음(전역 .tableA thead sticky 해제) */
    .help-table thead {
        position: static;
    }

    /* 섹션 구분 행: 표 안에서 그룹 제목 역할 */
    .help-table .help-section-row td {
        font-weight: 600;
        color: var(--primary-color);
    }

    /* 테이블 셀 내부 가변 텍스트: 전역 nowrap을 줄바꿈으로 예외 처리 */
    .help-table .menu-column {
        width: 9rem;
    }

    .help-table td {
        white-space: normal;
        text-overflow: clip;
        line-height: 1.5;
        vertical-align: top;
    }

    .help-desc {
        margin: 0;
    }

    .help-details {
        margin: 0.5rem 0 0;
        padding-left: 1.2rem;
    }

    .help-details li {
        margin-top: 0.25rem;
    }
</style>
